import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { DeltaMode } from '../../models/controls.model';

@Component({
    selector: 'delta-mode-toggle',
    template: `
        <div class="myc-btn-pair" role="radiogroup">
            <ham-button
                variant="primary"
                *ngIf="mode === 'pct'; else pctInactive"
                [attr.aria-checked]="true"
                role="radio">
                {{ 'aumico_analytics_controls_delta_pct' | i18next }}
            </ham-button>
            <ng-template #pctInactive>
                <ham-button
                    variant="white"
                    outline="true"
                    role="radio"
                    [attr.aria-checked]="false"
                    (buttonClick)="modeChange.emit('pct')">
                    {{ 'aumico_analytics_controls_delta_pct' | i18next }}
                </ham-button>
            </ng-template>

            <ham-button
                variant="primary"
                *ngIf="mode === 'chf'; else chfInactive"
                [attr.aria-checked]="true"
                role="radio">
                {{ 'aumico_analytics_controls_delta_chf' | i18next }}
            </ham-button>
            <ng-template #chfInactive>
                <ham-button
                    variant="white"
                    outline="true"
                    role="radio"
                    [attr.aria-checked]="false"
                    (buttonClick)="modeChange.emit('chf')">
                    {{ 'aumico_analytics_controls_delta_chf' | i18next }}
                </ham-button>
            </ng-template>
        </div>
    `,
    styleUrls: ['../shared-toggle-group.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeltaModeToggleComponent {
    @Input() public mode: DeltaMode = 'pct';
    @Output() public modeChange = new EventEmitter<DeltaMode>();
}
